import { useParams } from "react-router-dom";
import { db } from "../firebase";
import { createContext, useReducer, useEffect, useContext } from "react";
import { AppValue } from "./app";
import { PluginsValue } from "./plugins";
import __blocks from "../utils/blocks";
export const BlocksValue = createContext(null);
export const BlocksDisbatch = createContext(null);

const reducer = (state, action) => {
  const newState = { ...state };
  if (action.type === "set") {
    return action.value;
  } else {
    return newState;
  }
};

export default function BlocksContext({ children }) {
  const [state, dispatch] = useReducer(reducer, __blocks);
  const { components } = useContext(AppValue);
  const plugins = useContext(PluginsValue);

  useEffect(() => {
    const getBlocks = async () => {
      //PLUGINS
      const _plugins = Object.keys(plugins).map(async (key) => {
        const p = plugins[key];
        const components = await db
          .collection("plugins")
          .doc(p.plugin.name)
          .collection("versions")
          .doc(p.version)
          .collection("components")
          .get();
        const _components = components.docs.map((doc) => {
          return {
            ...doc.data(),
            id: doc.id,
            dynamic: { plugin: key, name: doc.data().name },
            name: p.plugin.name.toUpperCase() + doc.data().name,
            displayName: doc.data().displayName,
          };
        });
        return _components;
      });
      const blocks = await Promise.all(_plugins);
      const _blocks = [].concat.apply(__blocks, blocks);

      //components
      const _components = components.map((comp) => {
        return {
          name: comp.id,
          displayName: comp.name,
          type: "_component",
          props: Object.keys(comp.customProps).map((k) => {
            return {
              name: k,
              displayName: comp.customProps[k].name,
              editor: "dynamic",
              editorParams: {
                type: comp.customProps[k].type,
                list: comp.customProps[k].list,
                default: null,
              },
            };
          }),
          events: Object.keys(comp.customEvents || {}).map((k) => {
            return {
              name: k,
              displayName: comp.customEvents[k].displayName,
              params: [],
            };
          }),
        };
      });
      dispatch({ type: "set", value: [..._blocks, ..._components] });
    };
    getBlocks();
  }, [plugins]);

  return (
    <BlocksValue.Provider value={state}>
      <BlocksDisbatch.Provider value={dispatch}>
        {children}
      </BlocksDisbatch.Provider>
    </BlocksValue.Provider>
  );
}
